import { render, staticRenderFns } from "./ZxzczcBlock.vue?vue&type=template&id=368db162&scoped=true"
import script from "./ZxzczcBlock.vue?vue&type=script&lang=js"
export * from "./ZxzczcBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368db162",
  null
  
)

export default component.exports